import { render, staticRenderFns } from "./TechLayout.vue?vue&type=template&id=06648945&"
import script from "./TechLayout.vue?vue&type=script&lang=js&"
export * from "./TechLayout.vue?vue&type=script&lang=js&"
import style0 from "./TechLayout.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports